import axios from "axios";
import { Config } from "../../server-config";
import { refreshTokenGeneratorForBotSection } from "./auth.service";

export const getPromotions = async (token) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  return await axios.get(
    `https://${host}/${context}/mobileapp/teams/eligiblePromotions.action`,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
        "outlookauth": `${token}`,
      },
    }
  ).catch((error) => {
    if (error) {
      return error.response;
    }
  });
};
// have to change in  different place ...........................
export const getPoints = async (res) => {
  // console.log('Get points api call', res);
  return await axios.get(
    `https://${res.host}/${res.context}/mobileapp/outlook/teamsShopPoints.action`,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
        "outlookauth": `${res.token}`,
      },
    }
  ).catch((error) => {
    if (error) {
     return getRefreshTokenWithPoints(res);
    }
  });
};

// have to change in  different place ...........................
export const getSupportEmail = async (domain) => {
  const data = await axios.get(
    `${Config.GET_EMAIL_URL()}?domain=${domain}`
  ).catch((error) => {
    if (error) {
     // console.log(error);
    }
  });
  return data && data.data ? data.data : null;

};

export const getRefreshTokenWithPoints = async (res) => {
  const tokenResponse = await refreshTokenGeneratorForBotSection(res);
  const data = await axios.get(
    `https://${res.host}/${res.context}/mobileapp/outlook/teamsShopPoints.action`,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
        "outlookauth": `${tokenResponse.data.token}`,
      },
    }
  );
  return [data, tokenResponse.data];
};
